import { sessionSetup } from "SessionSetup"
import { api_link } from "siteConfig";
import axios from "axios";
import { SHA256 } from "crypto-js";

export const sendSMS = async (email, otp) => {
    let url = 'https://'+api_link+'supplier_portal/sendOTP'

    let otpsent = await axios({
        method: "post",
        url: url,
        data: {
            "referurl": url,
            "var1": email,
            "var2": otp
        },
        timeout: 5000,
        headers: {
            "api-key": "ad8acb-e20326-93d0b2-11e5f2-d78c2e",
            // "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json"
        }
    }).then(resp => {
        console.log(resp)
        if(resp.data.message === 'OTP sent successfully'){
            return true
        }
        else {
            return false
        }
    }).catch(err => {
        console.log(err)
    })

    return otpsent
}

export const loginHandler = async (email, password) => {
    let passed = false
    let salt = 'V8e0BZFb)QUR';
    let encryption = SHA256(password+salt).toString();
    let url = 'https://'+api_link+'supplier_portal/login'

    await axios({
        method: "post",
        url: url,
        data: {
            "referurl": url,
            "var1": email,
            "var2": encryption
        },
        timeout: 5000,
        headers: {
            "api-key": "ad8acb-e20326-93d0b2-11e5f2-d78c2e",
            // "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json"
        }
    }).then(resp => {
        console.log(resp)
        if(resp.data.message === 'Incorrect password' || resp.data.message === 'User not found'){
            passed = false
        }
        else {
            let fullname = resp.data.fullname
            let subcon_id = resp.data.subcon_id
            let user_id = resp.data.id
            let direct_attachment = resp.data.direct_attachment
            let role = resp.data.role

            sessionSetup(email, fullname, subcon_id, user_id, direct_attachment, role).then(() => {
                console.log('session setup done')
            })
            passed = true
        }
        
    }).catch(err => {
        console.log(err)
    })

    return passed
}